import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient'; // Certifique-se que o caminho está certo
import './LoginScreen.css';
import logo from '../assets/logo.png';

const LoginScreen = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMsg('');

    try {

      const { data: authData, error: authError } = await supabase.auth.signInWithPassword({
        email: email,
        password: password,
      });

      if (authError) throw authError;

      const userId = authData.user.id;
      console.log("Login realizado! ID:", userId);


      const { data: profileData, error: profileError } = await supabase
        .from('profiles')
        .select(`
          municipio_id,
          municipios (
            nome
          )
        `)
        .eq('id', userId)
        .single();

      if (profileError) {
        console.error("Erro ao buscar perfil:", profileError);


        throw new Error("Usuário sem município vinculado. Contate o suporte.");
      }

      if (!profileData?.municipio_id) {
        throw new Error("Seu usuário não está vinculado a nenhum município.");
      }


      const municipioId = profileData.municipio_id;
      const municipioNome = profileData.municipios?.nome || 'Município';

      localStorage.setItem('user_municipio_id', municipioId);
      localStorage.setItem('user_municipio_nome', municipioNome);

      console.log(`Acesso liberado para: ${municipioNome} (${municipioId})`);


      navigate('/formularios');

    } catch (error) {
      console.error("Erro de login:", error);
      setErrorMsg(error.message === "Invalid login credentials"
        ? "Email ou senha incorretos."
        : error.message || "Erro ao conectar.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="brand-section">
        <form className="login-form" onSubmit={handleLogin}>
          <h2>Acesse o Painel</h2>

          {errorMsg && <div className="error-message" style={{ color: 'red', marginBottom: '10px' }}>{errorMsg}</div>}

          <input
            type="email"
            placeholder="Email"
            className="login-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <input
            type="password"
            placeholder="Senha"
            className="login-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <button type="submit" className="login-button" disabled={loading}>
            {loading ? 'Entrando...' : 'Entrar'}
          </button>
        </form>
      </div>
      <div className="form-section">
        <img src={logo} alt="Vector Tracker Logo" className="login-logo" />
        <h1>Vector Tracker</h1>
        <p>Digitalizando a vigilância...</p>
      </div>
    </div>
  );
};

export default LoginScreen;